<script setup>
import { ref } from "vue";
import ContentFiltersSidebar from 'shared/components/contentLibrary/contentFiltersSidebar.vue';
import useContentLibrary from 'shared/components/contentLibrary/composables/useContentLibrary';

const contentLibrary = ref(useContentLibrary());
</script>

<template>
	<div
		class="c-content-sidebar__facet-overlay"
		:class="{ 'c-content-sidebar__facet-overlay--show': contentLibrary.showFilters }"
		@click="contentLibrary.filtersToggled"
		@keydown.enter.prevent="contentLibrary.filtersToggled"
		>
	</div>
	<content-filters-sidebar
		v-show="contentLibrary.filtersAreVisible"
		:both-filters-types-applied="contentLibrary.bothFiltersTypesApplied"
		:filters-label="
			contentLibrary.activeSidebarFiltersType !== 'month'
				? contentLibrary.filtersLabel
				: contentLibrary.monthFiltersLabel
		"
		:formatted-apply-filter-label="contentLibrary.formattedApplyFilterLabel"
		:reset-filters-label="contentLibrary.resetFiltersLabel"
		:show-filters="contentLibrary.showFilters"
		@toggle-filters="contentLibrary.filtersToggled"
	/>
</template>
